module.exports = __webpack_public_path__ + "img/logo.138cc084.jpg";